import { render, staticRenderFns } from "./msw-product-claims.vue?vue&type=template&id=8275617e&scoped=true&"
import script from "./msw-product-claims.vue?vue&type=script&lang=ts&"
export * from "./msw-product-claims.vue?vue&type=script&lang=ts&"
import style0 from "./msw-product-claims.vue?vue&type=style&index=0&id=8275617e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8275617e",
  null
  
)

export default component.exports